"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./lib/dataset/DatasetCoreWrapper"), exports);
__exportStar(require("./lib/dictionary/ITermDictionary"), exports);
__exportStar(require("./lib/dictionary/TermDictionaryNumberMap"), exports);
__exportStar(require("./lib/dictionary/TermDictionaryNumberRecord"), exports);
__exportStar(require("./lib/dictionary/TermDictionaryNumberRecordFullTerms"), exports);
__exportStar(require("./lib/dictionary/TermDictionaryQuoted"), exports);
__exportStar(require("./lib/dictionary/TermDictionaryQuotedIndexed"), exports);
__exportStar(require("./lib/dictionary/TermDictionaryQuotedReferential"), exports);
__exportStar(require("./lib/dictionary/TermDictionarySymbol"), exports);
__exportStar(require("./lib/index/IRdfStoreIndex"), exports);
__exportStar(require("./lib/index/RdfStoreIndexNestedMap"), exports);
__exportStar(require("./lib/index/RdfStoreIndexNestedMapQuoted"), exports);
__exportStar(require("./lib/index/RdfStoreIndexNestedMapRecursive"), exports);
__exportStar(require("./lib/index/RdfStoreIndexNestedMapRecursiveQuoted"), exports);
__exportStar(require("./lib/index/RdfStoreIndexNestedRecord"), exports);
__exportStar(require("./lib/index/RdfStoreIndexNestedRecordQuoted"), exports);
__exportStar(require("./lib/IRdfStoreOptions"), exports);
__exportStar(require("./lib/OrderUtils"), exports);
__exportStar(require("./lib/PatternTerm"), exports);
__exportStar(require("./lib/RdfStore"), exports);
//# sourceMappingURL=index.js.map